import type { GlobalScope } from '@xing-com/crate-xinglet/internal';

declare const globalThis: GlobalScope;

// NOTE: this is a 'magic' webpack variable to define a dynamic public path
// we use it to switch between local development, preview and public
// without requiring different bundles

// eslint-disable-next-line no-unused-vars
declare let __webpack_public_path__: string;
__webpack_public_path__ = `${globalThis.crate.assetsBaseUrl}/`;
